import React, { Component } from 'react';
import Tile from "../Results/tile";
import { connect } from "react-redux"
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { getNewPageSearch } from '../../actions/searchActions.js';
import searchVars from "../../searchVar.json";
const TILE_PER_PAGE = searchVars.TILE_PER_PAGE;
class tileList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageData: []
        }
        this.setData = this.setData.bind(this);
    }

    componentDidMount() {
        this.setData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setData();
        }
    }

    setData() {
        if (this.props.data) {
            const startPage = (this.props.page - 1) * TILE_PER_PAGE;
            const endPage = this.props.page * TILE_PER_PAGE;
            if (this.props.data.length < endPage) {
                this.setState({
                    pageData: this.props.data.slice(startPage, this.props.data.length)
                })
            }
            else {
                this.setState({
                    pageData: this.props.data.slice(startPage, endPage)
                })
            }
        }
    }

    changePage(event, pageNum) {
        event.preventDefault();
        getNewPageSearch(this.props.searchCriteria, pageNum, this.props.data.length, pageNum > this.props.page);
    }

    render() {
        const { data, page, lastPage } = this.props;
        const { pageData } = this.state;
        return (
            <div className="tileList__main">
                <h4 className="rides-tagline tileList__title">Résultats de recherche</h4>
                <div className="tileList__grid">
                    {data ? pageData.map((ride, i) => <Tile rideInfo={ride} key={ride.title + i} />) : ""}
                </div>
                <div className="tilePager">
                    <Button disabled={page === 1 ? true : false} onClick={(e) => this.changePage(e, page - 1)} className="prevButton">{<i class="fas fa-arrow-left"></i>}</Button>
                    <Button disabled={pageData.length % TILE_PER_PAGE !== 0 || lastPage ? true : false} className="nextButton" onClick={(e) => this.changePage(e, page + 1)}>{<i class="fas fa-arrow-right"></i>}</Button>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        data: state.reducerSearchResult.data,
        page: state.reducerSearchResult.page,
        searchCriteria: state.reducerSearchResult.searchCriteria,
        lastPage: state.reducerSearchResult.lastPage
    }
}
export default connect(mapStateToProps)(tileList)